// extracted by mini-css-extract-plugin
export var attachment = "_pa-a";
export var emailContainer = "_pa-4";
export var emailContentPaddedContainer = "_pa-b";
export var emailHeader = "_pa-6";
export var emailIframe = "_pa-3";
export var emailInfoIcon = "_pa-9";
export var emailShortenedSummary = "_pa-e";
export var infoDropdown = "_pa-0";
export var infoRowBoundedContent = "_pa-d";
export var internal = "_pa-5";
export var merchant = "_pa-8";
export var messageInputContainer = "_pa-h";
export var normal = "_pa-7";
export var replyCard = "_pa-f";
export var subtleButton = "_pa-1";
export var subtleButtonIconContainer = "_pa-2";
export var toggleViewRepliesButton = "_pa-c";
export var wrappingText = "_pa-g";